import React from 'react';

import isNil from '../../../../utils/isNil';
import { Spinner } from '../../../Spinner';
import { useSelectRootContext } from '../root/SelectRootContext';
import { useSelectTriggerContext } from '../trigger/SelectTrigger';

import { SelectArrow } from './SelectArrow/SelectArrow';
import { SelectClearButton } from './SelectClearButton';

import styles from './SelectIcon.module.scss';

export const SelectIcon = () => {
    const {
        readOnly,
        loading,
        mode,
        selection,
        value,
        isInlineInputSearchVisible,
        internalSearchValue
    } = useSelectRootContext();
    const { hasCustomInput, allowClear, showArrow } = useSelectTriggerContext();
    const { selectedOption } = selection;

    let iconNode = null;

    if (hasCustomInput) return null;

    const hasValidValue = String(value ?? '') !== '';
    const shouldShowClear =
        allowClear &&
        mode === 'single' &&
        !readOnly &&
        (!isNil(selectedOption) || (isInlineInputSearchVisible && hasValidValue));

    if (loading) {
        iconNode = <Spinner size={16} aria-label="loading..." aria-busy="true" />;
    } else if (shouldShowClear) {
        iconNode = <SelectClearButton />;
    } else if (!readOnly && showArrow && !internalSearchValue) {
        iconNode = <SelectArrow />;
    }

    if (isNil(iconNode)) return null;

    return <div className={styles.container}>{iconNode}</div>;
};
